import requestTimeout from '../common/requestTimeout'
import scrollTo from '../common/scrollTo'
import debounce from 'lodash/debounce'
import easydropdown from 'easydropdown-a11y'

const SELECTORS = Selectors({
  pageHeader: 'page-header',
  headerLinks: 'page-header-links',
  headerChildren: 'page-header-dropdown',
  pageHeaderMenu: 'page-header-menu'
})

const $pageHeader = document.querySelector(SELECTORS.asClass('pageHeader'))
const $headerLinks = document.querySelector(SELECTORS.asClass('headerLinks'))
const $headerChildren = document.querySelector(SELECTORS.asClass('headerChildren'))

const state = {
  $linksAsSelect: null,
  linksEdd: null
}

const fn = {
  init: () => {
    if ($headerLinks) {
      fn.setupLinks()
    }

    if ($headerChildren) {
      fn.setupChildren()
    }

    // Toggle class to trigger inner header content transition
    requestTimeout(() => {
      $pageHeader.classList.add('is-init')
    }, 500)
  },

  setupLinks: () => {
    const $selectWrapper = document.createElement('div')
    $selectWrapper.className = 'page-header-links__select styled-dropdown--header-links'

    const $selectEl = document.createElement('select')
    $selectEl.id = SELECTORS.pageHeaderMenu
    $selectEl.title = 'Page Menu'

    const $placeholderOption = document.createElement('option')
    $placeholderOption.dataset.placeholder = ''
    $placeholderOption.text = $headerLinks.dataset.menuTitle || 'Menu'
    $selectEl.appendChild($placeholderOption)

    for (const link of $headerLinks.querySelectorAll('a')) {
      const $option = document.createElement('option')
      $option.value = link.href
      $option.text = link.text
      $selectEl.appendChild($option)

      if (Object.prototype.hasOwnProperty.call(link.dataset, 'scroll')) {
        $selectWrapper.classList.add('as-anchors')
      } else {
        $selectWrapper.classList.add('as-links')
      }
    }

    $selectWrapper.appendChild($selectEl)

    state.$linksAsSelect = $selectWrapper

    window.addEventListener('resize', debounce(fn.updateLinks, 250))

    fn.updateLinks()
  },

  updateLinks: () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      $headerLinks.appendChild(state.$linksAsSelect)

      state.linksEdd = easydropdown(SELECTORS.asId('pageHeaderMenu'), {
        callbacks: {
          onSelect: (value) => {
            if (state.$linksAsSelect.classList.contains('as-anchors')) {
              const $target = document.querySelector(value.substr(value.indexOf('#')))

              if ($target) {
                scrollTo($target)

                state.linksEdd.value = ''
                state.linksEdd.refresh()
              }
            } else {
              window.location.href = value
            }
          }
        }
      })
    } else {
      const $select = $headerLinks.querySelector('.page-header-links__select')

      if (state.linksEdd) {
        state.linksEdd.destroy()
        state.linksEdd = null
      }

      if ($select) {
        $headerLinks.removeChild($select)
      }
    }
  },

  setupChildren: () => {
    easydropdown($headerChildren.querySelector('select'), {
      callbacks: {
        onSelect: (value) => window.location.href = value
      }
    })
  }
}

export default {
  can: () => document.contains($pageHeader),
  run: fn.init
}
